module.exports = __webpack_public_path__ + "img/hipaa-seal-dark.e7713e41.png";